var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.key,on:{"esailsEntityConfig-item-updated":_vm.refresh,"esailsEntityConfig-item-created":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }